






















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import ListDisplay from '@/components/common/modules/ListDisplay.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';

@Component({
  components: {
    MasterSelectMultiSetControl,
    ListDisplay,
    SelectNoVModel
  }
})
export default class ConfigurationTable extends Vue {
  @Prop({ default: () => ({}) })
  private item: any;
  @Prop({ default: () => ({}) })
  private configurationTableData: any;

  @Prop({ default: '' })
  private displayInfomation!: string;

  // セレクト内選択データ
  selectValue = {};
  // テキストフィールドデータ
  textValue = '';
  // どのダイアログマスタ定義を参照するか管理
  dialogMasterIndex = '';

  @Emit('tabChildrenEventRelay')
  private catchTableDataRelay(response: any) {
    response.functionName = 'getdataRelay';
    return response;
  }

  /**
   * 親コンポーネントにテキストフィールドで入力された行のアイテムをオブジェクトで返します
   * @module getData
   * @param inputValue - 入力値
   * @param inputName - 入力フィールド名
   * @param record - アイテム情報
   * @return { inputValue, inputName, itemIndex, record }
   */
  @Emit('tabChildrenEventRelay')
  getdataRelay(response: any) {
    response.functionName = 'getdataRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickItemAdditionButtonRelay(response: any) {
    response.functionName = 'clickItemAdditionButtonRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickDownloadButtonEventRelay(response: any) {
    response.functionName = 'clickDownloadButtonEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private masterSelectEventRelay(response: any) {
    response.functionName = 'masterSelectEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  private clickCheckBoxEventRelay(response: any) {
    response.functionName = 'clickCheckBoxEventRelay';
    return response;
  }

  @Emit('tabChildrenEventRelay')
  public changeSelectTemplete(response: any) {
    response.functionName = 'changeSelectTemplete';
    this.computedValue = response.value.value;

    return response;
  }

  @Emit('clickButton')
  public clickButton(response: any) {
    this.dialogMasterIndex = response.buttonName;
  }

  /**
   * コンポーネント内でテキストフィールドへの値反映を完結するため、
   * 算出プロパティを設定する（直接propsを変更できないため）
   */
  get computedValue() {
    return this.textValue;
  }
  set computedValue(newValue) {
    this.textValue = newValue;
  }
}
